// sagas.js
import { takeLatest, put, call } from "redux-saga/effects";
import { JOB_APPLY } from "../../../utility/constants";
import axios from "axios";
import {
  FETCH_JOB_APPLY_REQUEST,
  fetchJobApplySuccess,
  fetchJobApplyFailure,
} from "../../actions/fetchJobApplyActions";

function* fecthjobapply(action) {
  try {
    // Create a new FormData object to hold prayer data
    const jobFormData = new FormData();

    // Append prayer data fields to the FormData object
    jobFormData.append("job_id", action.payload.job_id );
    jobFormData.append("first_name", action.payload.first_name );
    jobFormData.append("last_name", action.payload.last_name );
    jobFormData.append("email_id", action.payload.email);
    jobFormData.append("phone_no", action.payload.phone_no);
    jobFormData.append("job_position", action.payload.job_position);
    jobFormData.append("description", action.payload.description);
    jobFormData.append("resume", action.payload.resume);
    const response = yield call(axios.post, JOB_APPLY, jobFormData, {
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    if (response.status === 200 && response.data.status === "Success") {
      yield put(fetchJobApplySuccess(response.data));
    }
  } catch (error) {
    yield put(fetchJobApplyFailure(error.message));
  }
}

export function* jobapplySaga() {
  yield takeLatest(FETCH_JOB_APPLY_REQUEST, fecthjobapply);
}
export default jobapplySaga;
